import { Outlet } from "react-router-dom";

const University = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default University;